import lessRequire from '../../../../../config/less-require-resolver';
import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, FormSection, Fields } from 'redux-form';
import classname from 'classname';
import values from 'lodash/values';

import Checkbox from '../../../../shared/form-elements/checkbox';
import ConditionValueInput from '../../../../shared/form-elements/input';

import ShowConditionsCheckbox from './checkbox-show-conditions';
import ConditionsRadio from './radio-condition-field';

lessRequire('modules/statistics/components/column-control/form/main.less');

const Form = ({ childColumns, type, onApply, onReset, dispatchFormAction, handleSubmit, reset, intl }) =>
	<form className="column-control-form" onSubmit={handleSubmit(data => onApply(data, type))}>
		<div className="column-control-form__groups">
			{values(childColumns).map((column, i) =>
				<FormSection name={column.id} key={i}>
					<Fields
						names={['isColumnVisible', 'couldShowConditions', 'conditionsType', 'conditionsValue']}
						columnId={column.id}
						columnName={column.title}
						dispatchFormAction={dispatchFormAction}
						shoulShowConditionsOption={!!column['conditionIndex']}
						component={renderFields}
						intl={intl}
					/>
				</FormSection>
			)}
		</div>

		<div className="column-control-form__btns">
			<button className="button yellow-btn apply-btn font-proxima-nova-semibold">{intl('Применить')}</button>
			<button
				className="reset-btn"
				onClick={e => {
					e.preventDefault();
					reset();
					onReset(type);
				}}
			/>
		</div>
	</form>;

Form.propTypes = {
	childColumns: PropTypes.object,
	type: PropTypes.string,
	onApply: PropTypes.func,
	onReset: PropTypes.func,
	dispatchFormAction: PropTypes.func,
	handleSubmit: PropTypes.func,
	reset: PropTypes.func,
	intl: PropTypes.func
};

const renderFields = fields => {
	const groupConditionsClassName = classname({
		'group-row': true,
		'group-condition': true,
		clearfix: true,
		'is-hidden': fields.isColumnVisible.input.value === false || !fields.couldShowConditions.input.value
	});

	return (
		<div className="column-control-form__group">
			<div className="group-row clearfix">
				<div className="position-left">
					<Checkbox
						{...fields.isColumnVisible}
						labelText={fields.intl ? fields.intl(fields.columnName) : fields.columnName}
					/>
				</div>
				{fields.shoulShowConditionsOption &&
					<div className="position-right">
						<ShowConditionsCheckbox
							{...fields.couldShowConditions}
							type={getShowConditionsCheckboxType(fields)}
							labelText={fields.conditionsValue.input.value}
							onClear={onSetZeroValue(fields)}
						/>
					</div>}
			</div>

			{fields.shoulShowConditionsOption &&
				<div className={groupConditionsClassName}>
					<div className="position-left">
						<ConditionsRadio
							{...fields.conditionsType}
							defaultValue="large"
							className="condition-large"
							shouldDisabled={fields.conditionsValue.input.value <= 0}
							onHideCondition={onHideConditionGroup(fields)}
						/>
					</div>

					<div className="position-left position-condition-wrap">
						<ConditionValueInput {...fields.conditionsValue} />
					</div>

					<div className="position-right">
						<ConditionsRadio
							{...fields.conditionsType}
							defaultValue="less"
							className="condition-less"
							shouldDisabled={fields.conditionsValue.input.value <= 0}
							onHideCondition={onHideConditionGroup(fields)}
						/>
					</div>
				</div>}
		</div>
	);
};

const getShowConditionsCheckboxType = fields => {
	let type = 'init';

	if (fields.conditionsValue.input.value > 0 && fields.conditionsType.input.value) {
		type = fields.conditionsType.input.value;
	}

	if (fields.isColumnVisible.input.value === false) {
		type = 'disabled';
	}

	return type;
};

const onHideConditionGroup = fields => () => {
	const field = `${fields.columnId}.couldShowConditions`;
	fields.dispatchFormAction('columnControlForm', field, false);
};

const onSetZeroValue = fields => () => {
	const field = `${fields.columnId}.conditionsValue`;
	fields.dispatchFormAction('columnControlForm', field, 0);
};

export default reduxForm({
	form: 'columnControlForm',
	enableReinitialize: true
})(Form);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/statistics/components/column-control/form/main.js